import { Box, Text } from "grommet"
import { Info } from "grommet-icons";
import { useTranslation } from "react-i18next";

export const InfoSection = ({ children }) => {

    const { t } = useTranslation('common');

    return (
        <Box direction="row" pad={{ vertical: 'small', horizontal: 'medium' }} style={{ position: "relative", borderLeft: 'none' }} round={{ corner: 'right', size: 'xsmall' }} border={{ size: '1px', color: 'background-contrast' }} background={'background-contrast'}>
            <Box width={'3px'} style={{ position: "absolute", left: 0, top: 0, bottom: 0 }} background={'brand'}></Box>
            <Box fill>
                <Box direction="row" align="center" gap="small"><Info size="medium" /><Text>{t('tips')}</Text></Box>
                {children}
            </Box>
        </Box>
    )
}